import axios from 'axios';

export const apiNoAlert = axios.create({
  baseURL: process.env.REACT_APP_HOST+'/'
})
